import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import SetAttributeOrderTable from "../../../../components/UI/table/orders/organization/order/SetAttributeOrderTable";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import AttributesService from "../../../../API/orders/orders/organization/AttributesService";

const SetAttributeOrder = () => {
    const params = useParams();
    const [data, setData] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    useEffect(() => {
        getStartPageSize()
        AttributesService.getAllCheckForOrder(params.id).then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/orders/set-attribute`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/orders/set-attribute`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Атрибуты"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заказы", href: "/organization/orders"}
                ]}/>

            <SetAttributeOrderTable
                idOrder={params.id}
                number={params.number}
                idHeader={params.idHeader}
                year={params.year}
                data={data}
                setData={setData}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
        </Box>
    );
};

export default SetAttributeOrder;